import { Separator, ContentBox } from '@/shared/ui'

import { RefundTermNotice } from './notice'
import {
  TerminationFee,
  type Props as TerminationFeeProps,
} from './termination-fee'

export type Props = TerminationFeeProps

export const RefundTerm = ({ isOldRefundTerms, refundTerms }: Props) => {
  return (
    <ContentBox color="gray" spacing="large" className="space-y-6 px-0">
      <TerminationFee
        isOldRefundTerms={isOldRefundTerms}
        refundTerms={refundTerms}
      />
      <Separator />
      <RefundTermNotice isOldRefundTerms={isOldRefundTerms} />
    </ContentBox>
  )
}
